import { Text } from 'components/@tedui';

import type { TitleProps } from './Title.props';

export function Title({ hasLargeText, text }: TitleProps): React.ReactNode {
  return (
    <div className="pb-4 md-tui:pb-8">
      <Text
        tag={hasLargeText ? 'h2' : 'p'}
        variant={hasLargeText ? 'header1' : 'body2'}
      >
        {text}
      </Text>
    </div>
  );
}
